import React from "react";
import { Link } from "@/i18n/router";
import { Seo } from "@/lib/seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Page not found" description="The page you are looking for does not exist." path="/404" />
      <section className="flex min-h-screen flex-col items-center justify-center bg-navy px-5 text-center">
        <span className="font-heading text-8xl font-black text-outline">404</span>
        <h1 className="mt-6 font-heading text-3xl font-bold text-white">Page not found</h1>
        <p className="mt-3 max-w-md text-silver/60">The page you are looking for may have moved or no longer exists.</p>
        <Link to="/" className="mt-8 inline-flex items-center gap-2 rounded-full bg-astro-blue px-7 py-3.5 font-semibold text-white hover:bg-astro-light transition-colors">
          Back to home
        </Link>
      </section>
    </>
  );
}
